import { Injectable } from '@angular/core';

/** Service que valida os acessos e execuções de funcionalidades dos tipos de arquivos */
@Injectable({
    providedIn: 'root'
})
export class TipoArquivoAuthGuardService {

    /** Verifica se pode editar um tipo de arquivo */
    canEdit(): boolean {
        return true;
    }

    /** Verifica se pode excluir um tipo de arquivo */
    canDelete(): boolean {
        return true;
    }
}
